import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Leaderboard = () => {
  const [bankScores, setBankScores] = useState([]);
  const [diceScores, setDiceScores] = useState([]);

  useEffect(() => {
    fetchTopScores();
  }, []);

  const fetchTopScores = async () => {
    try {
      const [bankRes, diceRes] = await Promise.all([
        axios.get(`/api/sessions/bank/top`),
        axios.get(`/api/sessions/dice/top`)
      ]);
      setBankScores(bankRes.data);
      setDiceScores(diceRes.data);
    } catch (error) {
      console.error('Error fetching top scores:', error);
    }
  };

  const formatCurrency = (value) => '$' + Math.abs(value).toFixed(0);

  return (
    <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", background: "#031A54", minHeight: "100vh", padding: "20px" }}>
      <div style={{ maxWidth: "1400px", margin: "0 auto", background: "white", borderRadius: "12px", boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)" }}>

        {/* Bank Scores Section */}
        <div style={{ background: "#9584AC", color: "white", padding: "25px", textAlign: "center" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>🏆 TOP BANK SCORES 🏆</h1>
          <p>Universal Bank Score Leaderboard</p>
        </div>

        <div style={{ padding: "20px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
            {bankScores.map((session, index) => (
              <div key={session._id} style={{
                background: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                border: "2px solid #9584AC",
                position: "relative"
              }}>
                <div style={{
                  position: "absolute",
                  top: "-15px",
                  left: "20px",
                  background: index === 0 ? "#FFD700" : index === 1 ? "#C0C0C0" : index === 2 ? "#CD7F32" : "#9584AC",
                  color: index < 3 ? "black" : "white",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontWeight: "bold",
                  fontSize: "0.9rem"
                }}>
                  #{index + 1}
                </div>
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#1e3c72", marginBottom: "10px" }}>
                    {session.user?.firstName || session.user?.nickname || 'Anonymous'}
                  </div>
                  <div style={{ fontSize: "2rem", fontWeight: "bold", color: "#2e7d32", marginBottom: "5px" }}>
                    {session.totals?.totalScore || 0}
                  </div>
                  <div style={{ fontSize: "0.9rem", color: "#666", marginBottom: "5px" }}>
                    Total Player Score
                  </div>
                  <div style={{ fontSize: "1rem", color: session.totals?.totalWL >= 0 ? "#2e7d32" : "#d32f2f" }}>
                    {session.totals?.totalWL >= 0 ? "+" : ""}{formatCurrency(session.totals?.totalWL || 0)} W/L
                  </div>
                  <div style={{ fontSize: "0.8rem", color: "#666", marginTop: "10px" }}>
                    {new Date(session.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dice Scores Section */}
        <div style={{ background: "#1e3c72", color: "white", padding: "25px", textAlign: "center", marginTop: "30px" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>🎲 TOP DICE SCORES 🎲</h1>
          <p>Dice Score Leaderboard</p>
        </div>

        <div style={{ padding: "20px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
            {diceScores.map((session, index) => (
              <div key={session._id} style={{
                background: "white",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                border: "2px solid #1e3c72",
                position: "relative"
              }}>
                <div style={{
                  position: "absolute",
                  top: "-15px",
                  left: "20px",
                  background: index === 0 ? "#FFD700" : index === 1 ? "#C0C0C0" : index === 2 ? "#CD7F32" : "#1e3c72",
                  color: index < 3 ? "black" : "white",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontWeight: "bold",
                  fontSize: "0.9rem"
                }}>
                  #{index + 1}
                </div>
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#1e3c72", marginBottom: "10px" }}>
                    {session.user?.firstName || session.user?.nickname || 'Anonymous'}
                  </div>
                  <div style={{ fontSize: "2rem", fontWeight: "bold", color: "#d32f2f", marginBottom: "5px" }}>
                    {session.diceScore || 0}
                  </div>
                  <div style={{ fontSize: "0.9rem", color: "#666", marginBottom: "5px" }}>
                    Dice Score
                  </div>
                  <div style={{ fontSize: "1rem", color: "#666" }}>
                    {session.numRolls || 0} Rolls
                  </div>
                  <div style={{ fontSize: "0.8rem", color: "#666", marginTop: "10px" }}>
                    {new Date(session.createdAt).toLocaleDateString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ padding: "15px", textAlign: "center", background: "#f5f5f5", color: "#666", fontSize: "0.85rem" }}>
          <p>Craps Players League ©2025</p>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;